import React from "react";
import "./DeployHerosection.css";
import heroimg from "../deployassets/heroimg.png";

export default function DeployHeroSection() {
  return (
    <div id="deploy-herosection" className="machinemainclass">
      <div className="left">
        <h1>Continuous Delivery & Deployment (CD)</h1>
        <p>
         Partner with India’s trusted machine learning experts delivering 95% model accuracy and enterprise-grade solutions. As one of the best machine learning development services, we help businesses reduce manual efforts, optimize workflows, and accelerate digital transformation with proven ML strategies.
        </p>
        <button>Let's Discuss Your Project</button>
      </div>
      <div className="right">
        <img src={heroimg} alt="error" />
      </div>
    </div>
  );
}
